import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgSurveyOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 80 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M63.333 10H49.4C48 6.133 44.333 3.333 40 3.333s-8 2.8-9.4 6.667H16.667C13 10 10 13 10 16.667v46.666C10 67 13 70 16.667 70h46.666C67 70 70 67 70 63.333V16.667C70 13 67 10 63.333 10zM40 10c1.833 0 3.333 1.5 3.333 3.333 0 1.834-1.5 3.334-3.333 3.334a3.343 3.343 0 0 1-3.333-3.334C36.667 11.5 38.167 10 40 10zm6.667 46.667H23.333V50h23.334v6.667zm10-13.334H23.333v-6.666h33.334v6.666zm0-13.333H23.333v-6.667h33.334V30z",
			fillOpacity: .3,
			fill: "#424D57",
			fillRule: "nonzero"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#6F7981",
			d: "M69.468 3l7.071 7.072L10.071 76.54 3 69.469z"
		})]
	})
});
export default SvgSurveyOff;
